export const APP_FORMAT_DATE = 'dd/MM/yyyy';
export const APP_FORMAT_TIME = 'HH:mm';
export const TIME_FORMAT_DATE = 'yyyy-MM-dd';
export const APP_FORMAT_DATE_TIME = `${APP_FORMAT_DATE} ${APP_FORMAT_TIME}`;
